var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgControllerPlay = function SvgControllerPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.82C1 1.515 3.488.071 5.488 1.214l7.315 4.18a2.965 2.965 0 0 1 1.503 2.395c.029.138.029.28 0 .418a2.966 2.966 0 0 1-1.503 2.396l-7.315 4.18C3.488 15.929 1 14.484 1 12.18V3.82Z",
    fill: "#fff"
  })));
};
export { SvgControllerPlay as ReactComponent };
export default "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">\n    <path d=\"M1 3.81912C1.00033 1.51589 3.48846 0.0718375 5.48828 1.21463L12.8027 5.39529C13.7406 5.93151 14.241 6.84749 14.3057 7.78982C14.3347 7.92763 14.3346 8.06995 14.3057 8.20779C14.2413 9.15064 13.7412 10.0679 12.8027 10.6043L5.48828 14.7849C3.48847 15.9276 1.0003 14.4827 1 12.1795V3.81912Z\" fill=\"white\"></path>\n</svg>";